import { addDays, setHours, setMinutes, startOfDay } from 'date-fns';

export interface ResourceScheduleTimeSlot {
  time: Date;
  label: string;
  isHalfHour?: boolean;
  /** 0 = selected date, 1 = next day, -1 = previous day */
  dayOffset: number;
}

/**
 * Generate rolling time slots that can cross midnight.
 * Hours >= 24 wrap to next day (00:00, 00:30, etc.).
 * Hours < 0 wrap to previous day.
 */
export function generateResourceScheduleTimeSlots(
  date: Date,
  startHour: number,
  hoursCount: number,
  intervalMinutes: number,
): ResourceScheduleTimeSlot[] {
  const slots: ResourceScheduleTimeSlot[] = [];
  const baseDate = startOfDay(date);

  for (let i = 0; i < hoursCount; i += 1) {
    const rawHour = startHour + i;
    let displayHour = rawHour;
    let dayOffset = 0;

    if (rawHour >= 24) {
      displayHour = rawHour - 24;
      dayOffset = 1;
    } else if (rawHour < 0) {
      displayHour = rawHour + 24;
      dayOffset = -1;
    }

    const slotDate = addDays(baseDate, dayOffset);

    for (let minute = 0; minute < 60; minute += intervalMinutes) {
      const time = setMinutes(setHours(slotDate, displayHour), minute);
      slots.push({
        time,
        label: `${String(displayHour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
        isHalfHour: minute === 30,
        dayOffset,
      });
    }
  }

  return slots;
}